import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { SettingPush } from "./SettingPush";

export function Settings() {
    return (
        <Switch>
            <Route path="/settings/push" component={SettingPush} />
            <Route path="*" render={() => <Redirect to="/settings/push" />} />
        </Switch>
    );
}
